import React from "react";
import { Typography } from "@mui/material";
import { Assessment as AnalyticsIcon } from "@mui/icons-material";
import PageContentLayout from "../components/layout/PageContentLayout";

const Analytics = () => {
  return (
    <PageContentLayout
      title="Analytics & Reports"
      subtitle="Comprehensive business analytics and insights"
      breadcrumbs={[
        { label: "Analytics & Reports", icon: <AnalyticsIcon sx={{ color: "#ffffff", fontSize: 18 }} /> },
      ]}
      backTo="/dashboard"
    >
      <Typography variant="body1" sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
        Analytics dashboard with revenue trends, conversion rates, churn analysis, and more coming soon...
      </Typography>
    </PageContentLayout>
  );
};

export default Analytics;
